'use client'

import { useEffect } from 'react'

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    console.error('Global error (root layout failed to render):', error)
  }, [error])

  return (
    <html lang="de">
      <body
        style={{
          margin: 0,
          fontFamily: 'system-ui, -apple-system, sans-serif',
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '2rem',
          backgroundColor: '#fff',
          color: '#111',
        }}
      >
        <div style={{ maxWidth: '32rem', textAlign: 'center' }}>
          <h1 style={{ fontSize: '4rem', margin: '0 0 1rem', fontWeight: 700 }}>500</h1>
          <h2 style={{ fontSize: '1.25rem', margin: '0 0 0.75rem', textTransform: 'uppercase' }}>
            Ein schwerer Fehler ist aufgetreten
          </h2>
          <p style={{ margin: '0 0 1.5rem', opacity: 0.75 }}>
            Die Anwendung konnte nicht geladen werden. Bitte versuchen Sie es erneut.
          </p>
          {error.digest && (
            <p style={{ fontFamily: 'ui-monospace, monospace', fontSize: '0.75rem', opacity: 0.4 }}>
              Referenz: {error.digest}
            </p>
          )}
          <button
            type="button"
            onClick={reset}
            style={{
              marginTop: '1.5rem',
              padding: '1rem 1.5rem',
              fontSize: '1rem',
              border: '1px solid #111',
              backgroundColor: '#111',
              color: '#fff',
              cursor: 'pointer',
              textTransform: 'uppercase',
            }}
          >
            Erneut versuchen
          </button>
        </div>
      </body>
    </html>
  )
}
